import React, { useCallback, useContext, useState } from 'react'
import { createPortal } from 'react-dom'

import { ToastElement, ToastOptions } from './ToastElement'

const ToastContainer = ({ toasts }: any) => {
  return createPortal(
    toasts.map((item: any) => (
      <ToastElement key={item.id} id={item.id} options={item.options}>
        {item.options.message}
      </ToastElement>
    )),
    document.querySelector('#root') as HTMLElement
  )
}

interface FeedbackContextInterface {
  showToast: (options: ToastOptions) => void
  hideToast: (id: string | number) => void
  hideToasts: () => void
}

const FeedbackContext = React.createContext<FeedbackContextInterface>({
  showToast: (options: ToastOptions) => {},
  hideToast: (id: string | number) => {},
  hideToasts: () => {},
})

let id = 1

export function FeedbackProvider({ children }: any) {
  const [toasts, setToasts] = useState<any>([])

  const showToast = useCallback(
    (options: any) => {
      setToasts(() => [
        {
          id: id++,
          options,
        },
      ])
    },
    [setToasts]
  )

  const hideToast = useCallback(
    (id: any) => {
      setToasts((toasts: any) => toasts.filter((t: any) => t.id !== id))
    },
    [setToasts]
  )

  const hideToasts = useCallback(() => {
    setToasts([])
  }, [setToasts])

  return (
    <FeedbackContext.Provider
      value={{
        showToast,
        hideToast,
        hideToasts,
      }}
    >
      <ToastContainer toasts={toasts} />
      {children}
    </FeedbackContext.Provider>
  )
}

const useFeedback = () => {
  const toastHelpers = useContext(FeedbackContext)

  return toastHelpers
}

export { FeedbackContext, useFeedback }
export default FeedbackProvider
